import "./../styles/LegalPages.css";

function TermsPage() {

return(

<div className="legal-page">

<div className="legal-container">

<h1>
    Conditions Générales d'Utilisation (CGU)
</h1>

<p>Dernière mise à jour : Juin 2026</p>

<section>
    <h2>Article 1 – Objet</h2>
    <p>Les présentes Conditions Générales d'Utilisation (CGU) définissent les règles applicables à l'utilisation de la plateforme FootVision Live, accessible à l'adresse https://footvisionlive.com.</p>
    <p>Toute utilisation du site implique l'acceptation pleine et entière des présentes conditions.</p>
</section>

<section>
    <h2>Article 2 – Présentation de FootVision Live</h2>
    <p>FootVision Live est une plateforme spécialisée dans le football proposant notamment :</p>
    <ul>
        <li>des analyses footballistiques ;</li>
        <li>des statistiques de matchs ;</li>
        <li>des compositions d'équipes ;</li>
        <li>des pronostics sportifs ;</li>
        <li>des contenus réservés aux membres VIP ;</li>
        <li>des actualités liées au football.</li>
    </ul>
    <p>Les informations publiées sont exclusivement destinées à informer les utilisateurs.</p>
</section>

<section>
    <h2>Article 3 – Acceptation des CGU</h2>
    <p>En créant un compte, en accédant au site ou en utilisant l'un quelconque des services proposés, l'utilisateur reconnaît avoir lu, compris et accepté les présentes Conditions Générales d'Utilisation.</p>
    <p>Si l'utilisateur refuse tout ou partie des présentes conditions, il doit immédiatement cesser d'utiliser FootVision Live.</p>
</section>

<section>
    <h2>Article 4 – Conditions d'accès</h2>
    <p>L'accès au site est gratuit.</p>
    <p>Certaines fonctionnalités sont toutefois réservées :</p>
    <ul>
        <li>aux utilisateurs disposant d'un compte ;</li>
        <li>aux membres VIP ;</li>
        <li>aux administrateurs de la plateforme.</li>
    </ul>
    <p>FootVision Live se réserve le droit de modifier les fonctionnalités accessibles selon le type de compte.</p>
</section>

<section>
    <h2>Article 5 – Création d'un compte</h2>
    <p>L'utilisateur peut créer un compte :</p>
    <ul>
        <li>à l'aide de son adresse électronique et d'un mot de passe ;</li>
        <li>via son compte Google lorsque cette fonctionnalité est disponible.</li>
    </ul>
    <p>L'utilisateur garantit que les informations fournies sont exactes, complètes et régulièrement mises à jour.</p>
    <p>Toute usurpation d'identité est strictement interdite.</p>
</section>

<section>
    <h2>Article 6 – Sécurité du compte</h2>
    <p>Chaque utilisateur est responsable de la confidentialité de ses identifiants.</p>
    <p>Il s'engage à :</p>
    <ul>
        <li>conserver son mot de passe secret ;</li>
        <li>ne jamais partager son compte ;</li>
        <li>informer immédiatement FootVision Live en cas d'utilisation frauduleuse.</li>
    </ul>
    <p>FootVision Live ne pourra être tenu responsable des conséquences d'une divulgation volontaire ou involontaire des identifiants par l'utilisateur.</p>
</section>

<section>
    <h2>Article 7 – Comptes Google</h2>
    <p>Lorsque la connexion via Google est utilisée :</p>
    <ul>
        <li>FootVision Live reçoit uniquement les informations nécessaires à l'authentification ;</li>
        <li>aucune donnée supplémentaire n'est collectée sans le consentement de l'utilisateur ;</li>
        <li>l'utilisateur peut à tout moment cesser d'utiliser cette méthode de connexion.</li>
    </ul>
</section>

<section>
    <h2>Article 8 – Utilisation normale du site</h2>
    <p>L'utilisateur s'engage notamment à :</p>
    <ul>
        <li>respecter les lois applicables ;</li>
        <li>utiliser les services de manière loyale ;</li>
        <li>ne pas perturber le fonctionnement du site ;</li>
        <li>ne pas tenter d'accéder aux systèmes internes ;</li>
        <li>respecter les autres utilisateurs.</li>
    </ul>
    <p>Toute utilisation abusive pourra entraîner la suspension ou la suppression du compte.</p>
</section>

<section>
    <h2>Article 9 – Comportements interdits</h2>
    <p>Il est notamment interdit de :</p>
    <ul>
        <li>publier des contenus illicites ;</li>
        <li>diffuser des propos haineux ou discriminatoires ;</li>
        <li>tenter de pirater le site ;</li>
        <li>utiliser des robots ou scripts automatisés sans autorisation ;</li>
        <li>revendre les contenus de FootVision Live ;</li>
        <li>copier massivement les analyses, statistiques ou pronostics publiés ;</li>
        <li>contourner les limitations techniques mises en place.</li>
    </ul>
    <p>FootVision Live pourra supprimer tout contenu ou compte ne respectant pas ces règles.</p>
</section>

<section>
    <h2>Article 10 – Nature des pronostics sportifs</h2>
    <p>Les pronostics publiés sur FootVision Live constituent exclusivement des analyses sportives reposant sur des statistiques, des informations disponibles et des méthodes d'analyse.</p>
    <p>Ils ne constituent jamais :</p>
    <ul>
        <li>une garantie de résultat ;</li>
        <li>une promesse de gain ;</li>
        <li>une certitude sportive ;</li>
        <li>un conseil financier ;</li>
        <li>une recommandation d'investissement.</li>
    </ul>
    <p>Le football est un sport soumis à de nombreux facteurs imprévisibles (forme des joueurs, blessures, décisions arbitrales, conditions météorologiques, événements de match, etc.).</p>
    <p>En conséquence, aucune prédiction ne peut garantir l'issue réelle d'une rencontre.</p>
</section>

<section>
    <h2>Article 11 – Abonnement VIP</h2>
    <p>FootVision Live propose un abonnement VIP permettant d'accéder à des fonctionnalités et contenus supplémentaires.</p>
    <p>Selon les évolutions de la plateforme, ces avantages peuvent notamment inclure :</p>
    <ul>
        <li>des compositions exclusives ;</li>
        <li>des analyses avancées ;</li>
        <li>des statistiques détaillées ;</li>
        <li>des pronostics premium ;</li>
        <li>un accès anticipé à certains contenus ;</li>
        <li>d'autres fonctionnalités réservées aux membres VIP.</li>
    </ul>
    <p>FootVision Live se réserve le droit de faire évoluer ces avantages à tout moment.</p>
</section>

<section>
    <h2>Article 12 – Paiement de l'abonnement</h2>
    <p>Les abonnements VIP sont payables via les moyens de paiement proposés sur la plateforme.</p>
    <p>À la date de publication des présentes CGU, FootVision Live utilise notamment :</p>
    <ul>
        <li>Flutterwave ;</li>
        <li>d'autres prestataires pouvant être ajoutés ultérieurement.</li>
    </ul>
    <p>Les paiements sont sécurisés par les prestataires concernés.</p>
    <p>FootVision Live ne conserve jamais les informations bancaires complètes des utilisateurs.</p>
</section>

<section>
    <h2>Article 13 – Activation du compte VIP</h2>
    <p>Après validation du paiement :</p>
    <ul>
        <li>le statut VIP est automatiquement activé ;</li>
        <li>la durée d'abonnement est enregistrée dans le compte utilisateur ;</li>
        <li>l'accès aux fonctionnalités VIP devient immédiatement disponible, sauf incident technique indépendant de la volonté de FootVision Live.</li>
    </ul>
</section>

<section>
    <h2>Article 14 – Expiration du statut VIP</h2>
    <p>À l'expiration de la période d'abonnement :</p>
    <ul>
        <li>le compte redevient automatiquement un compte standard ;</li>
        <li>les contenus réservés aux membres VIP ne sont plus accessibles.</li>
    </ul>
    <p>Aucun remboursement ne pourra être demandé au motif de l'expiration normale d'un abonnement.</p>
</section>

<section>
    <h2>Article 15 – Politique de remboursement</h2>
    <p>Sauf disposition légale impérative applicable, les abonnements déjà activés ne sont pas remboursables.</p>
    <p>Toute demande exceptionnelle pourra être étudiée individuellement sans créer d'obligation pour FootVision Live.</p>
</section>

<section>
    <h2>Article 16 – Disponibilité des services</h2>
    <p>FootVision Live s'efforce d'assurer un fonctionnement continu de la plateforme.</p>
    <p>Toutefois, des interruptions peuvent intervenir notamment pour :</p>
    <ul>
        <li>des opérations de maintenance ;</li>
        <li>des mises à jour ;</li>
        <li>des problèmes techniques ;</li>
        <li>des incidents liés aux fournisseurs de services ;</li>
        <li>des cas de force majeure.</li>
    </ul>
    <p>Ces interruptions ne donnent droit à aucune indemnisation.</p>
</section>

<section>
    <h2>Article 17 – Exactitude des analyses</h2>
    <p>Les analyses publiées sont élaborées avec le plus grand soin.</p>
    <p>Cependant elles reposent notamment sur :</p>
    <ul>
        <li>les statistiques ;</li>
        <li>les performances passées ;</li>
        <li>les compositions probables ;</li>
        <li>les blessures connues ;</li>
        <li>les suspensions ;</li>
        <li>les tendances observées.</li>
    </ul>
    <p>Malgré ces éléments, aucune analyse ne peut garantir le résultat futur d'un événement sportif.</p>
</section>

<section>
    <h2>Article 18 – Compositions de matchs</h2>
    <p>Les compositions publiées sur FootVision Live peuvent être :</p>
    <ul>
        <li>officielles ;</li>
        <li>probables ;</li>
        <li>prévisionnelles.</li>
    </ul>
    <p>Les compositions probables restent des estimations pouvant évoluer jusqu'au début de la rencontre.</p>
    <p>FootVision Live ne garantit jamais leur exactitude absolue.</p>
</section>

<section>
    <h2>Article 19 – Statistiques sportives</h2>
    <p>Les statistiques affichées proviennent principalement de fournisseurs spécialisés tels que API-SPORTS.</p>
    <p>Même si ces données sont réputées fiables, FootVision Live ne peut garantir l'absence totale d'erreurs ou de retards de mise à jour.</p>
</section>

<section>
    <h2>Article 20 – Responsabilité relative aux pronostics</h2>
    <p>Les pronostics proposés sur FootVision Live ne constituent jamais une garantie de victoire.</p>
    <p>Chaque utilisateur reconnaît expressément que :</p>
    <ul>
        <li>les événements sportifs demeurent imprévisibles ;</li>
        <li>un pronostic peut être correct ou incorrect ;</li>
        <li>les analyses constituent uniquement une aide à la décision.</li>
    </ul>
    <p>FootVision Live ne vend jamais une certitude.</p>
    <p>L'utilisateur comprend que les résultats sportifs dépendent de nombreux facteurs indépendants de la plateforme.</p>
</section>

<section>
    <h2>Article 21 – Responsabilité financière</h2>
    <p>Chaque utilisateur demeure seul responsable :</p>
    <ul>
        <li>des paris qu'il décide d'effectuer ;</li>
        <li>des montants engagés ;</li>
        <li>de la gestion de son budget ;</li>
        <li>des pertes éventuelles.</li>
    </ul>
    <p>En conséquence, FootVision Live ne pourra être tenu responsable :</p>
    <ul>
        <li>d'une perte financière ;</li>
        <li>d'un manque à gagner ;</li>
        <li>d'une mauvaise décision de pari ;</li>
        <li>d'un pari réalisé à partir d'une analyse publiée sur la plateforme.</li>
    </ul>
</section>

<section>
    <h2>Article 22 – Absence de conseil financier</h2>
    <p>Les contenus publiés sur FootVision Live ne constituent jamais :</p>
    <ul>
        <li>un conseil en investissement ;</li>
        <li>un conseil financier ;</li>
        <li>une recommandation personnalisée.</li>
    </ul>
    <p>Ils sont exclusivement destinés à fournir une information sportive.</p>
</section>

<section>
    <h2>Article 23 – Jeu responsable</h2>
    <p>FootVision Live encourage un usage responsable des paris sportifs.</p>
    <p>Les utilisateurs sont invités à :</p>
    <ul>
        <li>ne jamais parier des sommes qu'ils ne peuvent perdre ;</li>
        <li>fixer des limites de dépenses ;</li>
        <li>éviter toute pratique excessive ;</li>
        <li>respecter la législation de leur pays.</li>
    </ul>
    <p>La plateforme ne favorise ni ne promeut les comportements addictifs.</p>
</section>

<section>
    <h2>Article 24 – Protection des mineurs</h2>
    <p>FootVision Live est destiné aux personnes autorisées par la législation de leur pays à utiliser les services proposés.</p>
    <p>Les mineurs doivent respecter les lois locales relatives aux jeux d'argent et à l'utilisation des plateformes numériques.</p>
</section>

<section>
    <h2>Article 25 – Évolution des services</h2>
    <p>FootVision Live pourra, à tout moment :</p>
    <ul>
        <li>ajouter de nouvelles fonctionnalités ;</li>
        <li>supprimer certaines fonctionnalités ;</li>
        <li>modifier les services proposés ;</li>
        <li>améliorer l'interface ;</li>
        <li>adapter les offres VIP.</li>
    </ul>
    <p>Ces évolutions ne donnent droit à aucune indemnisation.</p>
</section>

<section>
    <h2>Article 26 – Propriété intellectuelle</h2>
    <p>L'ensemble des éléments présents sur FootVision Live, notamment :</p>
    <ul>
        <li>les analyses ;</li>
        <li>les statistiques ;</li>
        <li>les compositions de matchs ;</li>
        <li>les pronostics ;</li>
        <li>les textes ;</li>
        <li>les images ;</li>
        <li>les vidéos ;</li>
        <li>les graphismes ;</li>
        <li>les logos ;</li>
        <li>le design ;</li>
        <li>le code source ;</li>
        <li>la structure du site ;</li>
    </ul>
    <p>est protégé par les lois relatives à la propriété intellectuelle.</p>
    <p>Toute reproduction, copie, diffusion ou exploitation sans autorisation écrite préalable est strictement interdite.</p>
</section>

<section>
    <h2>Article 27 – Réutilisation des contenus</h2>
    <p>Les utilisateurs peuvent consulter les contenus publiés sur FootVision Live uniquement dans le cadre d'un usage personnel.</p>
    <p>Il est interdit de :</p>
    <ul>
        <li>republier les analyses ;</li>
        <li>recopier les pronostics ;</li>
        <li>vendre les contenus ;</li>
        <li>créer un site concurrent utilisant les informations de FootVision Live ;</li>
        <li>effectuer une extraction massive des données.</li>
    </ul>
    <p>Toute violation pourra entraîner des poursuites civiles ou pénales.</p>
</section>

<section>
    <h2>Article 28 – Disponibilité des informations</h2>
    <p>FootVision Live met tout en œuvre pour publier des informations fiables.</p>
    <p>Cependant, aucune garantie n'est donnée concernant :</p>
    <ul>
        <li>l'exactitude permanente des données ;</li>
        <li>l'absence d'erreurs humaines ;</li>
        <li>les retards de mise à jour ;</li>
        <li>les modifications de dernière minute concernant les équipes.</li>
    </ul>
    <p>Les utilisateurs reconnaissent utiliser ces informations à leurs propres risques.</p>
</section>

<section>
    <h2>Article 29 – API et fournisseurs tiers</h2>
    <p>Certaines données sont fournies par des prestataires spécialisés.</p>
    <p>En cas :</p>
    <ul>
        <li>d'indisponibilité ;</li>
        <li>d'erreur ;</li>
        <li>d'interruption ;</li>
        <li>de modification des services ;</li>
    </ul>
    <p>FootVision Live ne pourra être tenu responsable des conséquences résultant de ces fournisseurs tiers.</p>
</section>

<section>
    <h2>Article 30 – Publicités</h2>
    <p>Le site peut afficher des publicités provenant notamment de :</p>
    <ul>
        <li>Google AdSense ;</li>
        <li>partenaires commerciaux ;</li>
        <li>sponsors.</li>
    </ul>
    <p>FootVision Live ne garantit ni les produits ni les services proposés par ces annonceurs.</p>
    <p>Toute relation commerciale conclue avec un annonceur relève exclusivement de la responsabilité de l'utilisateur.</p>
</section>

<section>
    <h2>Article 31 – Suspension d'un compte</h2>
    <p>FootVision Live peut suspendre temporairement un compte en cas notamment de :</p>
    <ul>
        <li>fraude ;</li>
        <li>tentative de piratage ;</li>
        <li>utilisation abusive ;</li>
        <li>diffusion de contenus interdits ;</li>
        <li>comportement nuisible envers la plateforme ou les autres utilisateurs.</li>
    </ul>
    <p>La suspension peut intervenir sans préavis lorsque la sécurité du service l'exige.</p>
</section>

<section>
    <h2>Article 32 – Suppression définitive d'un compte</h2>
    <p>FootVision Live pourra supprimer définitivement un compte notamment en cas de :</p>
    <ul>
        <li>fraude répétée ;</li>
        <li>usurpation d'identité ;</li>
        <li>non-respect des présentes CGU ;</li>
        <li>tentative de coumtoirement des règles ;</li>
        <li>activité portant atteinte au fonctionnement de la plateforme.</li>
    </ul>
    <p>La suppression d'un compte n'ouvre droit à aucune indemnisation.</p>
</section>

<section>
    <h2>Article 33 – Fermeture volontaire du compte</h2>
    <p>L'utilisateur peut demander la suppression de son compte.</p>
    <p>Certaines données pourront néanmoins être conservées lorsque la loi l'impose ou pour permettre la défense des droits de FootVision Live.</p>
</section>

<section>
    <h2>Article 34 – Force majeure</h2>
    <p>FootVision Live ne pourra être tenu responsable d'une interruption ou d'une impossibilité d'exécuter tout ou partie de ses obligations résultant notamment :</p>
    <ul>
        <li>d'une catastrophe naturelle ;</li>
        <li>d'une guerre ;</li>
        <li>d'une panne majeure ;</li>
        <li>d'une cyberattaque ;</li>
        <li>d'une décision administrative ;</li>
        <li>d'une interruption des fournisseurs de services.</li>
    </ul>
</section>

<section>
    <h2>Article 35 – Limitation générale de responsabilité</h2>
    <p>Dans les limites autorisées par la loi, FootVision Live ne pourra être tenu responsable :</p>
    <ul>
        <li>des pertes financières ;</li>
        <li>des pertes de données ;</li>
        <li>des pertes d'exploitation ;</li>
        <li>des dommages indirects ;</li>
        <li>des décisions prises par les utilisateurs sur la base des informations publiées.</li>
    </ul>
    <p>L'utilisateur reconnaît utiliser la plateforme sous sa seule responsabilité.</p>
</section>

<section>
    <h2>Article 36 – Modification des CGU</h2>
    <p>FootVision Live peut modifier les présentes Conditions Générales d'Utilisation à tout moment.</p>
    <p>Les nouvelles versions prennent effet dès leur publication sur le site.</p>
    <p>L'utilisateur est invité à consulter régulièrement les présentes CGU.</p>
</section>

<section>
    <h2>Article 37 – Nullité partielle</h2>
    <p>Si une disposition des présentes CGU devait être déclarée invalide ou inapplicable, les autres dispositions conserveraient leur pleine validité.</p>
</section>

<section>
    <h2>Article 38 – Droit applicable</h2>
    <p>Les présentes Conditions Générales d'Utilisation sont régies par la législation applicable au siège de l'éditeur, sous réserve des dispositions impératives applicables aux utilisateurs résidant dans d'autres États.</p>
</section>

<section>
    <h2>Article 39 – Règlement des litiges</h2>
    <p>En cas de différend, les parties s'engagent à rechercher une solution amiable avant toute procédure judiciaire.</p>
    <p>À défaut d'accord, les juridictions compétentes seront celles déterminées par la législation applicable.</p>
</section>

<section>
    <h2>Article 40 – Contact</h2>
    <p>Pour toute question concernant les présentes Conditions Générales d'Utilisation, les utilisateurs peuvent contacter FootVision Live à l'adresse suivante :</p>
    <strong>contact@footvisionlive.com</strong>
    <p>Les demandes seront traitées dans les meilleurs délais.</p>
</section>



</div>

</div>

);

}

export default TermsPage;